import styled from 'styled-components';
import {
  defaultColor, font, radius, spacing,
} from 'styles/theme';

export const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('small')};
  padding: ${spacing('small')} ${spacing('medium')};
  margin-bottom: ${spacing('medium')};
  background: ${defaultColor('green', 0.1)};
  border: 1px solid ${defaultColor('green', 0.3)};
  border-radius: ${radius('small')};
  color: ${defaultColor('primary')};
  font-family: ${font('regular')};
  font-size: 0.9rem;
`;

export const Amount = styled.span`
  font-family: ${font('bold')};
  color: ${defaultColor('greenDark')};
`;
